// <template>
// <div>
// <div id="container" style="height:300px;width:50%"></div>
// <button width="50">fffd</button>
// <input></input>
// </div>

// </template>
// <script>
  import ChartMaker from './factory/gbasechart'
  import AnyChart from './factory/anychart'
  import HighChart from './factory/highchart'
  import EChart from './factory/echart'
import anychart from 'anychart'
  export default {
        name : 'Home',
        data() {
        return {
  
          branches: ['AnyChart', 'HighChart', 'EChart'],
          currentBranch: 'AnyChart',
      
          currentGenre: 'bar',
     
          }
        },
    created: function() {
      this.drawChart();
    },


    methods: {

      drawChart:function(){

var data = anychart.data.set([
  ["John", 10000],
  ["Jake", 12000],
  ["Peter", 13000],
  ["James", 10000],
  ["Mary", 9000]
]);

// create a chart

 //var stage = acgraph.create('container');
var chart = anychart.column();

// create a column series and set the data
var series = chart.column(data);

// set the container id
chart.container("container");

// initiate drawing the chart
chart.draw();


  
      },
 
    },


    }


// </script>



// WEBPACK FOOTER //
// ./src/Home.vue